export class OpeningHours {
}
//# sourceMappingURL=opening-hours.js.map